// extracted by mini-css-extract-plugin
export var quantityInput = "_fx-0";